function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowCircleDownOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.012 30.969c-8.24 0-14.98-6.74-14.98-14.98 0-8.241 6.74-14.981 14.98-14.981s14.98 6.74 14.98 14.98-6.74 14.98-14.98 14.98zm0-2.184c7.037 0 12.797-5.76 12.797-12.797 0-7.037-5.76-12.797-12.797-12.797-7.037 0-12.797 5.76-12.797 12.797 0 7.037 5.76 12.797 12.797 12.797z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.01 17.174l-1.415-1.415L17 19.355V8.77h-2v10.585l-3.596-3.596-1.414 1.415 6.01 6.01 6.01-6.01z",
    fill: props.color
  }));
}

export default SvgIconArrowCircleDownOutline;